import React from 'react';
import { CalendarIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { pageDetails } from '../Recoil/ActiveEvents';
import moment from 'moment';

function EventOverlay({ eventData }) {
  const [currEid, setCurrEid] = useRecoilState(pageDetails);
  
  if (!eventData) return null;
  
  const handleMoreInfoClick = () => {
    setCurrEid({...currEid, selectedEID: eventData.EventId});
  };

  return (
    <div 
      className="relative w-full py-12 md:py-16 pt-16 md:pt-20 z-10 bg-cover bg-center"
      style={{ 
        backgroundImage: eventData.ImgUrl ? `url(${eventData.ImgUrl})` : 'none',
        backgroundColor: eventData.ImgUrl ? 'transparent' : '#f3f4f6'
      }}
    >
      {/* Background Overlay */}
      <div className="absolute inset-0 bg-white/40 backdrop-blur-sm"></div>
      <div className="container-custom">
        <div className="max-w-6xl mx-auto bg-white/85 backdrop-blur-md rounded-2xl shadow-2xl border-2 border-white/40 shadow-inner hover:shadow-3xl transition-all duration-300 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            {/* Left Side - Image */}
            <div className="relative">
              <img 
                src="https://kalingarayanrunners.com/images/2431117_crop.png" 
                alt="Kalingarayan Runners Event" 
                className="w-full h-64 lg:h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-white/20"></div>
            </div>
            
            {/* Right Side - Content */}
            <div className="p-8 md:p-10 space-y-4 md:space-y-6 flex flex-col justify-center">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-neutral-800 leading-tight animate-slide-up drop-shadow-sm">
                {eventData.EventName}
              </h1>
              
              {eventData.EventDescription && (
                <p className="text-lg md:text-xl text-neutral-600 leading-relaxed animate-slide-up animation-delay-200">
                  {eventData.EventDescription}
                </p>
              )}
              
              <div className="flex flex-col sm:flex-row gap-4 md:gap-6 animate-slide-up animation-delay-300">
                {eventData.EventDate && (
                  <div className="flex items-center gap-2 text-neutral-600">
                    <CalendarIcon className="w-5 h-5 text-primary-500" />
                    <span className="text-lg font-medium">
                      {moment(eventData.EventDate).format('MMMM DD, YYYY')}
                    </span>
                  </div>
                )}
                
                {eventData.EventLocation && (
                  <div className="flex items-center gap-2 text-neutral-600">
                    <MapPinIcon className="w-5 h-5 text-primary-500" />
                    <span className="text-lg font-medium">
                      {eventData.EventLocation}
                    </span>
                  </div>
                )}
              </div>
              
              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-slide-up animation-delay-400">
                <Link 
                  to="/registration" 
                  className="relative overflow-hidden inline-flex items-center justify-center bg-gradient-to-r from-primary-600 to-primary-700 text-white font-semibold px-1 py-4 rounded-xl transition-all duration-300 hover:shadow-glow-primary hover:scale-105 shadow-lg border border-primary-600 min-w-[155px] text-center"
                >
                  <span className="relative z-10">Register Now</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </Link>

                <Link 
                  to="/volunteer-registration" 
                  className="relative overflow-hidden inline-flex items-center justify-center bg-white text-primary-600 font-semibold px-4 py-4 rounded-xl transition-all duration-300 hover:bg-neutral-100 border border-primary-300 shadow-lg min-w-[190px] text-center"
                >
                  <span className="relative z-10">Register Volunteer</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-neutral-100/50 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                </Link>
                
                <Link 
                  to="/galllery" 
                  onClick={handleMoreInfoClick}
                  className="relative overflow-hidden inline-flex items-center justify-center bg-white/95 text-neutral-700 font-semibold px-8 py-4 rounded-xl border border-neutral-300 transition-all duration-300 hover:bg-neutral-50 hover:border-neutral-400 hover:shadow-lg min-w-[140px] text-center"
                >
                  <span className="relative z-10">More Info</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-neutral-100/50 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EventOverlay;